import { useTranslation } from 'react-i18next';

import BannerFill from '../../../../../../../../../shared/components/Globals/BannerFill/BannerFill';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../../shared/translations/quotes';

export default function CensusErrorServiceStep() {
  const { t } = useTranslation();
  return (
    <div className="census-step">
      <BannerFill
        variant="danger"
        title={t(TRANSLATIONS_QUOTES.create.censusModal.errorServiceTitle)}
        description={t(TRANSLATIONS_QUOTES.create.censusModal.errorServiceDesc)}
        screenReaderLabel={t(TRANSLATIONS_QUOTES.create.censusModal.error)}
      />
      <div className="census-step__note">{t(TRANSLATIONS_QUOTES.create.censusModal.errorServiceNote)}</div>
    </div>
  );
}
